module.exports = __webpack_public_path__ + "img/copyright.dbaa2ad0.png";